import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import OrderCompactList from "../components/OrderCompactList";

const OrderSplitView = () => <MasterDetailLayout list={<OrderCompactList />} />;

export default OrderSplitView;
